module.exports = __webpack_public_path__ + "static/img/m_Deyubg_02.012286d9.jpg";